import DropdownItem, { type Props } from '@ui/Dropdown/DropdownItem';
import DropdownMenu from '@ui/Dropdown/DropdownMenu';

const Dropdown: typeof DropdownMenu & { Item?: typeof DropdownItem } = DropdownMenu;
Dropdown.Item = DropdownItem;

export * from '@ui/Dropdown/DropdownItem';
export * from '@ui/Dropdown/DropdownMenu';

export type { Props as DropdownItemProps };

export default Dropdown;
